import { lazy } from 'react';

const PlanUpgradedModal = lazy(() => import('./plan-upgraded-modal'));
const TrialExpirationReminderHeader = lazy(() => import('./trial-expiration-reminder-header'));
const UpgradeCancelModal = lazy(() => import('./upgrade-cancel-modal'));

export {
  PlanUpgradedModal,
  TrialExpirationReminderHeader,
  UpgradeCancelModal,
};
